<template>
    <div class="mx-16">
        <h1 class="mb-8 text-3xl font-black text-blue-600">
            CRI <span class="text-2xl font-normal">BusinessPlan</span>
        </h1>
        <div>
            <div class="grid grid-cols-3 gap-16">
                <span class="flex items-center text-blue-600 ">
                    <svg
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        class="w-10 h-10"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    <span class="text-lg">Retour</span></span
                >
                <span class="text-2xl font-extrabold text-blue-600 uppercase">
                    Business Plan De Admin
                </span>
            </div>
            <div class="w-32 mx-auto border-b-4 border-blue-600 rounded"></div>
            <ul class="grid grid-cols-1 gap-5 mt-6 lg:grid-cols-4">
                <li
                    v-for="(step, index) in steps"
                    :key="index"
                    class="items-center mb-5 bg-white "
                >
                    <div
                        class="flex items-center h-24 overflow-hidden bg-blue-600 rounded-lg shadow min-h-6 "
                    >
                        <div
                            class="flex items-center justify-center px-4 py-4 mx-auto my-auto text-lg font-extrabold text-white sm:p-6 xl:text-xl max-w-3/4"
                        >
                            {{ step.title }}
                        </div>
                    </div>
                    <ul>
                        <li
                            v-for="(subStep, index) in step.subSteps"
                            :key="index"
                            class="mt-3"
                        >
                            <div
                                class="overflow-hidden bg-gray-200 rounded-lg shadow min-h-6 h-lg"
                            >
                                <div>
                                    <div class="w-full bg-gray-300 ">
                                        <div
                                            class="py-1 text-xs leading-none bg-red-500 "
                                            style="width: 30%"
                                        ></div>
                                    </div>
                                </div>
                                <div
                                    class="flex items-center justify-center h-full px-4 py-5 mx-auto text-lg font-extrabold text-gray-600 sm:p-3 xl:text-xl max-w-3/4"
                                >
                                    {{ subStep.title }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            steps: [
                {
                    title: "Vous et votre projet",
                    subSteps: [
                        {
                            title: "Profils des investisseurs"
                        },
                        {
                            title: "Votre projet"
                        }
                    ]
                },
                {
                    title: "Etude de marché",
                    subSteps: [
                        {
                            title: "Taille et évolution du marché"
                        },
                        {
                            title: "Santé financière Des entreprises"
                        },
                        {
                            title: "Principaux acteurs et part du marché"
                        },
                        {
                            title: "Analyse Concurrentielle"
                        },
                        {
                            title: "Analyse De la demande"
                        },
                        {
                            title: "Moyens Commerciaux"
                        }
                    ]
                },
                {
                    title: "Etude Technique",
                    subSteps: [
                        {
                            title: "Moyens fonciers et immeubles"
                        },
                        {
                            title: "Moyens d’exploitation"
                        },
                        {
                            title: "Moyens humains"
                        }
                    ]
                },
                {
                    title: "Etude Financiere",
                    subSteps: [
                        {
                            title:
                                "Programme d’investissement plan de financement "
                        },
                        {
                            title: "Chiffres d’affaires Prévisionnels "
                        },
                        {
                            title: "Achats Prévisionnels"
                        },
                        {
                            title: "Autres charges externes"
                        },
                        {
                            title: "Charges du personnel"
                        }
                    ]
                }
            ]
        };
    }
};
</script>

<style></style>
